import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Auth, Cache } from 'aws-amplify';
import { environment } from '../../../environments/environment';
import { DevImpersonationService } from '../_services/dev-impersonation.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate, CanActivateChild {

  constructor(
	private router: Router,
	private roleOverrideService: DevImpersonationService
  ) { }

  canActivate(next: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
		const userAttr = this.roleOverrideService.getUserAttributes();
		const userRole = userAttr ? userAttr['custom:role'] : null;

		if (next.data.roles && userRole && next.data.roles.indexOf(userRole) === -1) {
			this.router.navigate(['login']);
			return false;
		} else {
			return true;
		}
  }

  canActivateChild(route: ActivatedRouteSnapshot,
					state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.canActivate(route, state);
	}
}
